import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 4;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'labels-overview',
      title: `Labels Overview <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'Labels add an extra dimension to your tracking — use them for departments, events, grants, campaigns, or any category that cuts across your fund structure. Labels are optional on transactions.',
      attachTo: { element: '[data-tour="labels-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'labels-edit-toggle',
      title: `View & Edit Modes <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Switch to Edit mode to add, rename, reorder, or disable labels. Drag and drop to reorganize labels within and between groups.',
      attachTo: { element: '[data-tour="labels-edit-toggle"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'labels-group',
      title: `Label Groups <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Labels are organized into groups for easy management. Click group headers to expand or collapse. In reports, you can filter by label to see spending on a specific event or program.',
      attachTo: { element: '[data-tour="labels-group"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'labels-add',
      title: `Add Labels <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'Create new labels or label groups here. Labels appear as an option when entering transactions and can be used to filter any report.',
      attachTo: { element: '[data-tour="labels-add"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'labels',
  pathPattern: '/foundation/labels-list',
  getSteps,
  label: 'Labels Tour',
});
